<template>
<v-select box :disabled="disabled" :clearable="clearable" :multiple="multiple" v-model="selectedDevices" :items="allDevices" :rules="rules" :label="label" :no-data-text="$t('device.no_device_available')">
  <template slot="item" slot-scope="data">
    <v-list-tile-avatar>
      <img :src="$FuncTypeIcons[data.item.functype||data.item.ctrltype]"></img>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>{{data.item.text}}</v-list-tile-title>
      <v-list-tile-sub-title class="caption">{{data.item.hostname}}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action style="min-width:12px">
      <v-checkbox color="primary" v-model="data.tile.props.value"></v-checkbox>
    </v-list-tile-action>
  </template>
</v-select>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'DeviceSelector',
  mixins: [UserAuth],
  props: {
    value: {
      type: [String, Array]
    },
    label: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    clearable: {
      type: Boolean
    },
    rules: {
      type: Array
    },
    functypes: {
      type: Array
    },
    ctrltypes: {
      type: Array
    },
    gateways: {
      type: Array
    }
  },
  watch: {
    value(val) {
      if (typeof val === 'string' || val instanceof String) {
        let [mac, uid] = val.split('-');
        let existed = !!(this.userDevice[mac] || {})[`${mac}-${uid}`];
        if (!existed) this.selectedDevices = null;
      }
      if (val instanceof Array) {
        let filtered = val.filter(key => {
          let [mac, uid] = key.split('-');
          return !!(this.userDevice[mac] || {})[`${mac}-${uid}`];
        });
        if (val.length != filtered.length) {
          this.selectedDevices = filtered;
        }
      }
    }
  },
  computed: {
    selectedDevices: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    allDevices() {
      let list = [];
      Object.values(this.userDevice).forEach(g => {
        Object.values(g).forEach(d => {
          Object.values(d.channel || {}).forEach(c => {
            if (this.functypes && !this.functypes.includes(c.functype)) return;
            if (this.ctrltypes && !this.ctrltypes.includes(c.ctrltype)) return;
            if (this.gateways && !this.gateways.includes(c.mac)) return;
            list.push({
              ...c,
              value: `${c.mac}-${c.uid}-${c.cid}`,
              text: ((this.userTargetName[c.mac] || {})[c.uid] || {})[c.cid] || c.name,
              battery: d.battery,
              hostname: (this.userMacInfo[c.mac] || {}).hostname,
              targetName: ((this.userTargetName[c.mac] || {})[c.uid] || {})[c.cid]
            });
          })
        });
      });
      return list;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceSelector.vue